import Button from "components/Button";
import { fireToast } from "services/sweetAlertConfig";
import * as S from "./styles";
import { HistoricItem } from "interfaces/Historic";

type OccurrenceListProps = {
  occurrences: HistoricItem[];
  onReportButtonClick: (occurrence: HistoricItem) => void;
};

export default function OccurrenceList({
  occurrences = [],
  onReportButtonClick,
}: OccurrenceListProps) {
  function formatDate(occurrenceDate: Date) {
    function addZero(i: string | number) {
      if (Number(i) < 10) {
        i = "0" + i;
      }
      return i;
    }
    const date = new Date(occurrenceDate);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const dt = addZero(date.getDate());
    const hour = addZero(date.getHours());
    const minutes = addZero(date.getMinutes());
    const seconds = addZero(date.getSeconds());

    return (
      dt +
      "/" +
      month +
      "/" +
      year +
      " às " +
      hour +
      ":" +
      minutes +
      ":" +
      seconds
    );
  }

  function formatAddress(occurrence: HistoricItem) {
    return (
      occurrence?.street +
      ", " +
      occurrence?.number +
      " - " +
      occurrence?.uf +
      " | CEP: " +
      occurrence?.postalCode
    );
  }

  return (
    <S.ListContainer>
      {occurrences.map((occurrence) => (
        <S.ListRow
          onClick={() => onReportButtonClick(occurrence)}
          title="Ver relatório"
        >
          <S.ListRowData>
            <p title="Protocolo">Protocolo</p>
            <p>
              {occurrence.protocol}
            </p>
          </S.ListRowData>
          <S.ListRowData>
            <p title="Tipo" >Tipo</p>
            <p>
              {(occurrence.patrimonialType === 1
                ? "Estabelecimento"
                : "Veicular") ?? "--"}
            </p>
          </S.ListRowData>

          <S.ListRowData>
            <p title="Criado em">Criado em</p>
            <p title={formatDate(occurrence.createdAt)}>
              {formatDate(occurrence.createdAt) ?? "--"}
            </p>
          </S.ListRowData>

          <S.ListRowData>
            <p title="Boletim">Boletim</p>
            <p>{occurrence.numberBO ?? "Sem boletim"}</p>
          </S.ListRowData>

          <S.ListRowData>
            <p title="Atendente">Atendente</p>
            <p title={occurrence.attendantName}>
              {occurrence.attendantName ?? "--"}
            </p>
          </S.ListRowData>


          <S.ListRowData>
            <p title="Subcliente">Subcliente</p>
            <p
              title={
                occurrence.superficialClientName
              }
            >
              {occurrence.superficialClientName ?? "--"}
            </p>
          </S.ListRowData>

          <S.ListRowData className="address">
            <p title="Endereço">Endereço</p>
            <p className="address" title={formatAddress(occurrence)}>
              {formatAddress(occurrence)}
            </p>
          </S.ListRowData>

          <S.ListRowData>
            <p title="Prestador">Prestador</p>
            <p title={occurrence?.policemanName}>
              {occurrence?.policemanName ?? "--"}
            </p>
          </S.ListRowData>

          <S.ListRowData>
            <p title="Tipo do prestador">Tipo do prestador</p>
            <p
              title={
                occurrence.workType === "Policial"
                  ? "Pronta-resposta"
                  : "Assistente"
              }
            >
              {occurrence.workType === "Policial"
                ? "Pronta-resposta"
                : "Assistente"}
            </p>
          </S.ListRowData>
        </S.ListRow>
      ))}
    </S.ListContainer>
  );
}
